import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortBy',
    pure: false
})
export class SortByPipe implements PipeTransform {

    transform(arr: Array<any>, sortField: string): Array<any> {
        if (sortField && sortField.length) {
            arr.sort((v1, v2) => {
                return v1[sortField] - v2[sortField];
            });
        }
        return arr;
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/pipes/sortBy.pipe.ts